import {Modal} from 'antd';
import {CreateStoreInput, useCreateStoreMutation} from 'api/generated';
import {storesQuery} from 'api/queries';
import {Formik, FormikHelpers} from 'formik';
import React, {useState} from 'react';
import {StoreForm, validationSchema} from './CreateStoreForm';
import {AnchorLink} from 'components';
import {omitEmpty} from 'lib/omitEmpty';

type Props = {
  accountId: string;
};

export const CreateStore: React.FC<Props> = ({accountId}) => {
  const [isOpen, setOpen] = useState(false);
  const [createStore] = useCreateStoreMutation({
    updateQuery: {query: storesQuery, variables: {accountId}}
  });

  const handleSubmit = async (
    input: CreateStoreInput,
    {setSubmitting}: FormikHelpers<CreateStoreInput>
  ) => {
    try {
      await createStore({
        variables: {input: omitEmpty(input)}
      });
      setOpen(false);
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <>
      <AnchorLink onClick={() => setOpen(true)}>Add new store</AnchorLink>
      <Formik<CreateStoreInput>
        onSubmit={handleSubmit}
        initialValues={{
          name: '',
          email: '',
          phone: '',
          iban: '',
          accountId
        }}
        validationSchema={validationSchema}>
        {({handleSubmit, isSubmitting, resetForm}) => (
          <Modal
            open={isOpen}
            destroyOnClose
            afterClose={resetForm}
            bodyStyle={{paddingBottom: 0}}
            title="Add new store"
            okText="Add"
            cancelText="Cancel"
            confirmLoading={isSubmitting}
            onOk={() => handleSubmit()}
            onCancel={() => {
              setOpen(false);
              resetForm();
            }}>
            <StoreForm layout="vertical" />
          </Modal>
        )}
      </Formik>
    </>
  );
};
